import React from "react";
import { Link } from "react-router-dom";
import {
  Clock3,
  ArrowLeft,
  Rocket,
} from "lucide-react";

export default function ComingSoon({
  title = "Coming Soon",
  subtitle = "We're currently building this page. Please check back shortly.",
}) {
  return (
    <main className="min-h-screen bg-[#fafafa] flex items-center justify-center px-5 py-20">
      <div className="max-w-3xl w-full text-center">
        {/* Badge */}

        <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-[#ef2435]/10 border border-[#ef2435]/20 mb-8">
          <Clock3
            size={16}
            className="text-[#ef2435]"
          />

          <span className="text-[#ef2435] text-xs uppercase tracking-[0.25em] font-semibold">
            Under Development
          </span>
        </div>

        {/* Icon */}

        <div className="w-28 h-28 rounded-[32px] bg-white shadow-sm border border-[#ececef] flex items-center justify-center mx-auto mb-8">
          <Rocket
            size={48}
            className="text-[#ef2435]"
          />
        </div>

        {/* Title */}

        <h1 className="text-5xl md:text-7xl font-black text-gray-900 leading-[0.95] mb-6">
          {title}
        </h1>

        {/* Subtitle */}

        <p className="text-gray-600 text-lg leading-9 max-w-2xl mx-auto mb-10">
          {subtitle}
        </p>

        {/* Buttons */}

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="h-14 px-8 rounded-full bg-[#ef2435] text-white font-semibold inline-flex items-center justify-center hover:bg-[#d91f30] transition-colors"
          >
            <ArrowLeft
              size={16}
              className="mr-2"
            />
            Back To Home
          </Link>

          <Link
            to="/contact"
            className="h-14 px-8 rounded-full border border-[#ececef] bg-white text-gray-900 font-semibold inline-flex items-center justify-center hover:border-[#ef2435] hover:text-[#ef2435] transition-colors"
          >
            Contact Us
          </Link>
        </div>

        {/* Bottom Text */}

        <div className="mt-16 pt-8 border-t border-[#ececef]">
          <p className="text-xs uppercase tracking-[0.25em] text-gray-500">
            SSC READY MIX CONCRETE
          </p>
        </div>
      </div>
    </main>
  );
}